import styled from 'styled-components';
import { LI_HEIGHT } from '../../styles/constants';

export const FormStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  color: #080808;
  font-size: 16px;
  line-height: 24px;

  @media screen and (min-width: 560px) {
    padding: 0;
  }
  img {
    user-select: none;
  }
  input {
    &[type='radio'],
    &[type='checkbox'] {
      position: absolute;
      width: 1px;
      height: 1px;
      opacity: 0;
    }
    &[type='radio']:disabled + label {
      opacity: 0.5;
    }
    &[type='checkbox'] + label,
    &[type='radio'] + label {
      line-height: 24px;
      min-height: ${LI_HEIGHT};
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    &[type='checkbox'] + label > svg,
    &[type='radio'] + label > svg {
      margin-right: 16px;
      flex-shrink: 0;
    }
    &[type='checkbox'] + label > div,
    &[type='radio'] + label > div {
      cursor: pointer;
    }
  }
`;
